import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initTheme } from './lib/theme';
import './styles.css';

// Apply theme from localStorage. Belt-and-suspenders alongside the
// inline script in index.html — protects against any module-load race.
initTheme();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);